import {
    SET_APITRAFFICEMAIL_DASHBOARD_INSIGHT,
    CLEAR_APITRAFFICEMAIL_DASHBOARD_INSIGHT,
    GET_APITRAFFICEMAIL_DASHBOARD_INSIGHT_SUCCESS,
    GET_APITRAFFICEMAIL_DASHBOARD_INSIGHT_FAILED
} from '../../actions/type';

const initialStateAPITrafficEmailDashboardInsight = { data: null, status: 'idle' };

export default function APITrafficEmailDashboardInsightReducer(state = initialStateAPITrafficEmailDashboardInsight, action) {
    const { type, data } = action;

    switch (type) {
        case SET_APITRAFFICEMAIL_DASHBOARD_INSIGHT:
            return {
                ...state,
                data,
            }
        case CLEAR_APITRAFFICEMAIL_DASHBOARD_INSIGHT:
            return {
                ...state,
                data: null,
            }
        case GET_APITRAFFICEMAIL_DASHBOARD_INSIGHT_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_APITRAFFICEMAIL_DASHBOARD_INSIGHT_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}